import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';

export class CreateEventAttendance {
  public limit: number;
  public signUpEndDate: string = '';

  public rules: { [key: string]: FormValidationFunction[] } = {
    limit: [
      (v: number) => !!v || 'This field is required.',
    ],
    signUpEndDate: [],
  };
}
